import { useNavigate } from "react-router-dom";
// import Navbar from "../component/common/navbar/NavBar";
import "../index.css";
// import Navbar from "../component/navbar/Navbar";
// import HeroSection from "../screens/FirstSection/HeroSection";
// import ThirdSection from "../screens/ThirdSection/ThirdSection";
// import SecondSection from "../screens/SecondSection/SecondSection";
// import FiftSection from "../screens/FiftSection/FiftSection";
// import FourthSection from "../screens/FourthSection/FourthSection";
// import Footer from "../screens/Footer/Footer";


function Home() {
  const navigate = useNavigate();

  return (
    <div >
      {/* <Navbar />
      <HeroSection />
      <SecondSection />
      <ThirdSection />
      <FiftSection />
      <FourthSection />
      <Footer /> */}
    </div>
  );
}

export default Home;
